module.exports = __webpack_public_path__ + "static/hero-bg@2x-63079875f29a8f05b452011102ba8e67.png";